import React from 'react';
import { Control, DeepMap, FieldError } from 'react-hook-form';
import InputWithController from '../../../shared/form/hookForms/InputWithController';

const CreateModalBody = ({
  control,
  errors,
  onChange,
}: {
  //    eslint-disable-next-line
  control: Control<Record<string, any>>;
  //    eslint-disable-next-line
  onChange: (name: string, value: any, config?: Object) => void;
  //    eslint-disable-next-line
  errors?: DeepMap<Record<string, any>, FieldError>;
}) => {
  return (
    <InputWithController
      name={'name'}
      label={'Name'}
      control={control}
      onChange={onChange}
      errors={errors}
      isRequired
      testId={'name'}
    />
  );
};

export default CreateModalBody;
